import {lazy} from 'react'

// Components

export const MathAdaptiveAssignmentsHandler = lazy(
  () => import('./../../../../../common/components/add-assignment/common/adaptive-assignments')
)

export const MathAssessmentAssignmentsHandler = lazy(
  () =>
    import('./../../../../../common/components/add-assignment/common/math-assessment-assignments')
)

export const MathFactPracticeHandler = lazy(
  () => import('./../../../../../common/components/add-assignment/common/fact-practice-assignments')
)

export const MathNumberFactsAssignmentsHandler = lazy(
  () => import('./../../../../../common/components/add-assignment/common/number-facts-assignments')
)

export const ChromelessMathTargetedAssignmentsHandler = lazy(
  () =>
    import('../../../../../common/components/add-assignment/common/chromeless-targeted-assignments')
)

export const MathTargetedAssignmentsHandler = lazy(
  () => import('./../../../../../common/components/add-assignment/common/targeted-assignments')
)

export const ChromelessMathTargetedDepthOfKnowledgePracticeAssignmentsHandler = lazy(
  () =>
    import('../../../../../common/components/add-assignment/common/chromeless-targeted-depth-of-knowledge-practice-assignments')
)

export const MathTargetedDepthOfKnowledgePracticeAssignmentsHandler = lazy(
  () =>
    import('./../../../../../common/components/add-assignment/common/targeted-depth-of-knowledge-practice-assignments')
)

export const MathFocusSkillsPracticeAssignmentsHandler = lazy(
  () => import('../../../../../pages/assign-focus-skills-practice/math')
)
